import { FieldNumberOutlined, UserOutlined } from '@ant-design/icons';
import { Form, Input } from "antd";
import { AgentDef } from "../../apis/mgmt/api";
import { DataForm } from "../common/DataForm";
import { DataViewProps } from "../common/DataView";
import { DomainForm } from '../domain/DomainForm';
import { DomainFormItem, DomainSelect } from '../domain/DomainSelect';


export const AgentDefForm = function (
    props: DataViewProps<AgentDef>
) {

    return (
        <DataForm {...props}>

            {/* id */}
            <Form.Item
                className="input"
                name="id"
                hidden={props.data?.id === undefined}
            >
                <Input prefix={<FieldNumberOutlined className="site-form-item-icon" />} placeholder="ID" disabled={true} />
            </Form.Item>

            {/* name */}
            <Form.Item 
                className="input"
                name="name"
                rules={[{ required: true, message: '¡Please input your Name!' }]}
            >
                <Input prefix={<UserOutlined className="site-form-item-icon" />} placeholder="Name" />
            </Form.Item>


            {/* domain */}
            <DomainFormItem
                name="domains"
                rules={[{ required: true, message: '¡Please select the domains!' }]}
            >
                <DomainSelect mode='multiple'/>
            </DomainFormItem>
            
            {/* url */}
            {/* <Form.Item
                className="input"
                name="url"
                rules={[{ required: true, message: '¡Please input your URL!' }]}
            >
                <Input prefix={<PaperClipOutlined className="site-form-item-icon" />} placeholder="URL" />
            </Form.Item> */}
     
        </DataForm>
    );

};
